<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista proformas</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/ventas/proformas/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear proforma </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid">
                <div class="input-group" style="width: 105%;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt"></i>
                    </span>
                  </span>
                  <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>N° Proforma</th>
                  <th>Fecha emisión</th>
                  <th>Cliente</th>
                  <th>N° celular</th>
                  <th>Total</th>
                  <th>Vencimiento</th>
                  <th class="text-center">Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <!-- <a class="grid__link" (click)="detail(item.id)">
                        {{item.nro_voucher}} <i class="fas fa-external-link-alt m-l-5"></i>
                      </a> -->
                      <span class="bold">{{item.nro_voucher}}</span>
                    </td>
                    <td>{{item.date_issue | date: 'mediumDate'}}</td>
                    <td>
                      <p class="m-b-0">{{item.client_data.fullname}}</p>
                      <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} : {{item.client_data.document}}</p>
                    </td>
                    <td>{{item.cellphone}}</td>
                    <td>
                      {{toolsService.momeySol()}}{{item.total}}
                    </td>
                    <td>{{item.date_expiration | date: 'mediumDate'}}</td>
                    <td class="text-center">
                      <span class="badge f-s-12 badge-{{item.status.class}}">{{item.status.msg}}</span>
                    </td>
                    <td class="text-center">
                      <a class="m-r-10" target="_blank" href="/{{branchofficeSlug}}/api/proformas/print/document/{{item.id}}">
                        <i class="far fa-file-pdf f-s-15 text-warning"></i>
                      </a>
                      <a class="btn p-5 pointer text-danger bold" (click)="delete(item, i)">
                        <i class="far fa-trash-alt"></i>
                      </a>
                      <a class="btn p-5 pointer text-success bold" (click)="edit(item.id)">
                        <i class="fas fa-pencil-alt"></i>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
